import React from "react";
import { Box, Typography } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const DeleteTooltip = ({ message }) => {
  if (!message) return null;

  return (
    <Box>
      <Typography
        variant="body2"
        fontWeight="700"
        sx={{ fontFamily: "inherit", fontSize: "14px" }}
      >
        {message.title}
      </Typography>

      <Box sx={{ mt: "4px" }}>
        {message.reasons.map((reason) => (
          <Box
            key={reason}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              ml: "10px",
            }}
          >
            <FiberManualRecordIcon
              sx={{ fontSize: 6, color: "#FFF", flexShrink: 0 }}
            />
            <Typography
              variant="body2"
              sx={{ fontFamily: "inherit", fontSize: "14px" }}
            >
              {reason}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default DeleteTooltip;
